import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckIcon } from '@wkda/icons';
import cx from 'classnames';
import * as styles from './CheckBox.module.scss';
export function CheckBox({ isChecked, className, toggle, name, value, }) {
    return (_jsxs("div", { className: styles.wrapper, children: [_jsx("input", { name: name, className: cx(styles.checkBox, className), type: "checkbox", checked: isChecked, onChange: toggle, value: value, "data-qa-selector": `gdpr-banner-check-box-${value}` }), isChecked ? (_jsx(CheckIcon, { onClick: toggle, className: styles.icon })) : null] }));
}
